import React from 'react';
import { SavedReportsTranslation } from '../../constants';
import { ListItemHeader } from 'app/area/shared/list-components/list-item-header';
import { GenericSavedReport } from '../../types-store';
import { SavedReportTileHeader } from './saved-report-tile-header';

import styles from './saved-report-drag-preview.scss';

export const renderSavedReportDragPreview =
  <SavedReport extends GenericSavedReport>(translation: SavedReportsTranslation) =>
    (savedReport: SavedReport) =>
      !!savedReport && <div className={styles.dragPreview}>
        <ListItemHeader>
          <SavedReportTileHeader
            savedReport={savedReport}
            canDrag={true}
            disabledLabel={translation.disabled} />
        </ListItemHeader>
      </div>;
